// @ts-nocheck
import React from 'react';
import { HydratedPost } from '../types';
import { PostGrid } from './PostGrid';

export const HashtagPage = ({
    tag,
    posts,
    onPostClick,
    onLike,
    onBump,
    onBookmark,
    onNavigateToProfile,
    onNavigateToHashtag,
    onNavigateToCommunity,

    animatingLikes,
    animatingBumps,
    animatingBookmarks,
    galleryAnimation,
    postBlurOpacity,
    gridColumns = 1,
    onMuteUser,
    onBlockUser,
    onGrantAdmin,
    onDeleteUser,
    onReportPost,
    isDemo = false,
    isModalOpen = false,
    onGridColumnsChange,
    preferredScale = 1,
    onScaleChange,
    onSwipeTransition,
    onShare,
    initialVisibleCount,
    onVisibleCountChange,
    closeInternalModalsTrigger,
    isLoading,
    isShakingMode = false,
    postcardGap = 8,
    onPostcardGapChange,
    onPostDragProgress
}: {
    tag: string,
    posts: HydratedPost[],
    onPostClick: (post: HydratedPost) => void,
    onLike: (postId: number) => void,
    onBump: (post: HydratedPost) => void,
    onBookmark: (postId: number) => void,
    onNavigateToProfile: (userId: string) => void,
    onNavigateToHashtag: (tag: string) => void,
    onNavigateToCommunity?: (id: string, channelId?: string) => void,

    animatingLikes: Set<number>,
    animatingBumps: Set<number>,
    animatingBookmarks: Set<number>,
    galleryAnimation: string,
    postBlurOpacity: number,
    gridColumns?: 1 | 2 | 3 | 4 | 5 | 6,
    onMuteUser?: (userId: string) => void,
    onBlockUser?: (userId: string) => void,
    onGrantAdmin?: (userId: string) => void,
    onDeleteUser?: (userId: string) => void,
    onReportPost?: (postId: number) => void,
    isDemo?: boolean,
    isModalOpen?: boolean,
    onGridColumnsChange?: (cols: 1 | 2 | 3 | 4 | 5 | 6) => void,
    preferredScale?: number,
    onSwipeTransition?: (direction: 'left' | 'right') => void,
    onScaleChange?: (scale: number) => void,
    onShare?: (post: HydratedPost, slideIndex?: number) => void,
    initialVisibleCount?: number,
    onVisibleCountChange?: (count: number) => void,
    onInternalModalStateChange?: (isOpen: boolean) => void,
    closeInternalModalsTrigger?: number,
    isLoading?: boolean,
    isShakingMode?: boolean,
    postcardGap?: number,
    onPostcardGapChange?: (gap: number) => void,
    onPostDragProgress?: (post: any, progress: number, direction: 'left' | 'right' | null) => void;
}) => {
    return (
        <div className="flex flex-col h-full mt-4">
            <h2 className="text-3xl font-black text-center text-white mb-6 uppercase tracking-wider text-raised">#{tag}</h2>
            <PostGrid
                posts={posts}
                onPostClick={onPostClick}
                onLike={onLike}
                onBump={onBump}
                onBookmark={onBookmark}
                onEdit={() => { }}
                onDelete={() => { }}
                onNavigateToProfile={onNavigateToProfile}
                onNavigateToHashtag={onNavigateToHashtag}
                onNavigateToCommunity={onNavigateToCommunity}
                onMuteUser={onMuteUser}
                onBlockUser={onBlockUser}
                onGrantAdmin={onGrantAdmin}
                onDeleteUser={onDeleteUser}
                onReportPost={onReportPost}
                animatingLikes={animatingLikes}
                animatingBumps={animatingBumps}
                animatingBookmarks={animatingBookmarks}
                galleryAnimation={galleryAnimation}
                postBlurOpacity={postBlurOpacity}
                preferredColumns={gridColumns}
                onColumnsChange={onGridColumnsChange}
                preferredScale={preferredScale}
                onScaleChange={onScaleChange}
                onSwipeTransition={onSwipeTransition}
                showEndMessage={false}
                isDemo={isDemo}
                isModalOpen={isModalOpen}
                onShare={onShare}
                initialVisibleCount={initialVisibleCount}
                onVisibleCountChange={onVisibleCountChange}
                closeInternalModalsTrigger={closeInternalModalsTrigger}
                isLoading={isLoading}
                isShakingMode={isShakingMode}
                postcardGap={postcardGap}
                onPostcardGapChange={onPostcardGapChange}
                onPostDragProgress={onPostDragProgress}
            />
        </div>
    );
};
